import { useState } from 'react';
import {
  HashRouter as Router,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
import AuthProvider from './auth/AuthProvider';
import { useAuth } from './auth/useAuth';
import LoginScreen from './components/LoginScreen';
import Overview from './components/Overview';
import PaymentHistory from './components/PaymentHistory';
import Plans from './components/Plans';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';

function SecurityLoadingScreen() {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-[#f4f2ff]">
      <div role="status" className="text-xl font-bold text-[#8c3af0] animate-pulse">
        Initializing security…
      </div>
    </div>
  );
}

function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'initializing') return <SecurityLoadingScreen />;
  if (status !== 'authenticated') {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return <Outlet />;
}

function LoginRoute() {
  const { status } = useAuth();
  if (status === 'initializing') return <SecurityLoadingScreen />;
  if (status === 'authenticated') return <Navigate to="/" replace />;
  return <LoginScreen />;
}

function PortalLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen w-full overflow-hidden bg-[#f4f2ff] font-sans">
      {isSidebarOpen && (
        <div
          className="fixed inset-0 z-40 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      <div className="hidden lg:block lg:relative lg:translate-x-0">
        <Sidebar />
      </div>

      <main className="flex h-screen flex-1 flex-col overflow-hidden">
        <Topbar isMenuOpen={isSidebarOpen} setIsMenuOpen={setIsSidebarOpen} />
        <div className="custom-scrollbar flex-1 overflow-y-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginRoute />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<PortalLayout />}>
          <Route path="/" element={<Overview />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/history" element={<PaymentHistory />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}
